(function(){
  'use strict';
  var KEY='pure_wishlist';
  var wl={
    getAll:function(){ try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];} },
    save:function(items){ localStorage.setItem(KEY,JSON.stringify(items)); },
    has:function(id){ return this.getAll().some(function(p){return String(p.id)===String(id);}); },
    add:function(p){ var items=this.getAll(); if(!this.has(p.id)){items.push(p);this.save(items);} },
    remove:function(id){ this.save(this.getAll().filter(function(p){return String(p.id)!==String(id);})); },
    toggle:function(btn){
      var id=btn.dataset.id,title=btn.dataset.title,url=btn.dataset.url,img=btn.dataset.img;
      if(this.has(id)){
        this.remove(id); btn.classList.remove('pure-wl-btn--active');
        btn.setAttribute('aria-label','Ajouter aux favoris'); this.toast('Retiré des favoris');
      } else {
        this.add({id:id,title:title,url:url,img:img}); btn.classList.add('pure-wl-btn--active');
        btn.setAttribute('aria-label','Retirer des favoris'); this.toast('Ajouté aux favoris');
      }
      this.updateCount();
    },
    toast:function(msg){
      var t=document.querySelector('.pure-wl-toast'); if(t)t.remove();
      t=document.createElement('div'); t.className='pure-wl-toast'; t.textContent=msg;
      document.body.appendChild(t);
      setTimeout(function(){t.classList.add('pure-wl-toast--show');},10);
      setTimeout(function(){t.classList.remove('pure-wl-toast--show');setTimeout(function(){t.remove();},400);},2400);
    },
    updateCount:function(){
      var n=this.getAll().length;
      document.querySelectorAll('.pure-wl-count').forEach(function(el){
        el.textContent=n||''; el.style.display=n>0?'flex':'none';
      });
    },
    openDrawer:function(){
      var drawer=document.getElementById('pure-wl-drawer');
      var body=document.getElementById('pure-wl-drawer-body');
      if(!drawer||!body)return;
      var items=this.getAll();
      if(items.length===0){
        body.innerHTML='<p class="pure-wl-drawer__empty">Aucun article en favoris pour l\'instant.</p>';
      } else {
        body.innerHTML=items.map(function(p){
          return '<div class="pure-wl-drawer__item">'+
            '<a href="'+p.url+'" class="pure-wl-drawer__img"><img src="'+p.img+'" alt="'+p.title+'" loading="lazy"></a>'+
            '<div class="pure-wl-drawer__info"><div class="pure-wl-drawer__name">'+p.title+'</div>'+
            '<a href="'+p.url+'" class="pure-wl-drawer__cta">Voir le produit →</a></div>'+
            '<button class="pure-wl-drawer__rm" onclick="pureWishlist.removeItem(\''+p.id+'\')">✕</button>'+
          '</div>';
        }).join('');
      }
      drawer.classList.add('pure-wl-drawer--open');
      document.body.style.overflow='hidden';
    },
    closeDrawer:function(){
      var drawer=document.getElementById('pure-wl-drawer');
      if(drawer)drawer.classList.remove('pure-wl-drawer--open');
      document.body.style.overflow='';
    },
    removeItem:function(id){
      this.remove(id);
      document.querySelectorAll('.pure-wl-btn[data-id="'+id+'"]').forEach(function(btn){
        btn.classList.remove('pure-wl-btn--active');
        btn.setAttribute('aria-label','Ajouter aux favoris');
      });
      this.updateCount(); this.openDrawer();
    },
    initButtons:function(){
      var self=this;
      document.querySelectorAll('.pure-wl-btn').forEach(function(btn){
        if(self.has(btn.dataset.id)){ btn.classList.add('pure-wl-btn--active'); btn.setAttribute('aria-label','Retirer des favoris'); }
        btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); self.toggle(btn); });
      });
    },
    init:function(){ this.initButtons(); this.updateCount(); }
  };
  window.pureWishlist=wl;
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){wl.init();}); }
  else{ wl.init(); }
})();